import React, {createContext, useReducer} from 'react'
import {AssociateScanReducer} from "../reducers/AssociateScanReducer";

export const AssociateScanContext = createContext();

const AssociateScanContextProvider = (props) => {

    const associateScanData = {
        chartData: {
            granularity: "15m",
            selectedAssociates: [],
        },
        scanMetrics: {},
        associateList: [],
    };

    const [ viewModel, dispatch ] = useReducer(AssociateScanReducer, associateScanData);
    return (
        <AssociateScanContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </AssociateScanContext.Provider>
    )
}

export default AssociateScanContextProvider


// WEBPACK FOOTER //
// ./src/components/associate/context/AssociateScanContext.js